module.exports = __webpack_public_path__ + "static/media/Beep.e981c2ff.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/App/config/Beep.mp3
// module id = 1539
// module chunks = 0